import { AuthenticateWithRedirectCallback } from "@clerk/react";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import { AriaWidget } from "./components/AriaWidget";
import { Home } from "./pages/Home";
import { Pricing } from "./pages/Pricing";
import { Signup } from "./pages/Signup";
import { CLERK_ENABLED } from "./config";
import { RouterProvider, useRouter } from "./router";

function Routes() {
  const { path } = useRouter();
  switch (path) {
    case "/pricing":
      return <Pricing />;
    case "/signup":
      return <Signup />;
    // OAuth signups round-trip through the provider and land here; Clerk completes the
    // handshake and redirects into the patient portal. Unused on keyless builds.
    case "/sso-callback":
      return CLERK_ENABLED ? <AuthenticateWithRedirectCallback /> : <Home />;
    case "/":
      return <Home />;
    default:
      return <Home />;
  }
}

export function App() {
  return (
    <RouterProvider>
      <Nav />
      <main>
        <Routes />
      </main>
      <Footer />
      <AriaWidget />
    </RouterProvider>
  );
}
